import { get as httpGet } from './BackendService';
import { listUrls } from './UrlsService';

export type QueryParamUsage = {
  paramName: string;
  count: number;
  urlCount: number;
};

export type QueryParamAggregation = {
  queryParams: QueryParamUsage[];
  totalUrlsWithParams: number;
};

export type ParamUrlsPage = { urls: string[]; hasMore: boolean };

export const PAGE_SIZE = 50;

const ERE_METACHARACTERS = /[.^$*+?()[\]{}|\\]/g;

const escapeEre = (value: string): string => value.replace(ERE_METACHARACTERS, '\\$&');

// ponytail: anchor on [?&] so the name matches a whole query-string key, never a
// suffix of a longer one (id must not match sid); the trailing group ends the
// name at =, &, # or string end so valueless params (?amp, ?amp&x=1) still match.
const parameterRegex = (parameter: string): string => `[?&]${escapeEre(parameter)}(=|&|#|$)`;

const basePath = (userId: number): string => `/users/${userId}/urls/query-params`;

export const getQueryParamAggregation = (userId: number): Promise<QueryParamAggregation> =>
  httpGet<QueryParamAggregation>(basePath(userId));

export const getUrlsWithParam = async (userId: number, parameter: string, offset = 0): Promise<ParamUrlsPage> => {
  const result = await listUrls(userId, PAGE_SIZE, offset, undefined, parameterRegex(parameter), undefined, false);
  const urls = Array.from(new Set(result.urls.map((entry) => entry.url)));
  return { urls, hasMore: result.urls.length === PAGE_SIZE };
};
